export const CONFERENCE_INFO = {
    alwaysVisible: ['raised-hands-count', 'recording', 'e2ee', 'video-quality'],
    autoHide: [
        'highlight-moment',
        'subject',
        'conference-timer',
        'participants-count',
        'transcribing',
        'visitors-count',
        'insecure-room',
        'top-panel-toggle'
    ]
};
